var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('i',{staticClass:"el-icon-check"}),_c('h1',[_vm._v("您已成功提交")])])])
}]

export { render, staticRenderFns }